import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export type SaveLoadDocumentAttachment = {
  externalId?: string;
  fileName?: string;
  mimeType?: string;
  contentBase64?: string;
};

export type SaveLoadDocumentsRequest = {
  emailExternalId?: string;
  messageType?: string;
  attachments: SaveLoadDocumentAttachment[];
};

export type SaveLoadDocumentResult = {
  attachmentExternalId?: string;
  fileName: string;
  success: boolean;
  docNum?: string;
  wasRenamed?: boolean;
  error?: string;
};

export type SaveLoadDocumentsResponse = {
  results: SaveLoadDocumentResult[];
};

export async function saveLoadDocuments(
  loadId: number,
  body: SaveLoadDocumentsRequest
): Promise<Result<SaveLoadDocumentsResponse, ApiError>> {
  try {
    const resp = await axios.post<SaveLoadDocumentsResponse>(
      `/load/${loadId}/documents`,
      body
    );
    return ok(resp.data);
  } catch (error) {
    captureException(error, { functionName: 'saveLoadDocuments' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to save attachments to TMS' });
    }

    if (error.response?.status === 401) {
      throw error;
    }

    if (error.message === 'Extension context invalidated.') {
      throw error;
    }

    const message =
      (typeof error.response?.data === 'object' &&
        error.response?.data &&
        'message' in error.response.data &&
        String((error.response.data as { message?: string }).message)) ||
      error.response?.data ||
      'Failed to save attachments to TMS';

    return err({
      message:
        typeof message === 'string'
          ? message
          : 'Failed to save attachments to TMS',
    });
  }
}
